import styled from 'styled-components';
import media from 'styled-media-query';

import { ColumnContent } from 'styles/ColumnContent';

export const CustomColumnContent = styled(ColumnContent)`
    border-bottom: 1px solid #BDBDBD;
    margin-bottom: 4rem;
`;

export const UserTypeContentTitle = styled.p`
    color: var(--main-color);
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 2.5rem;

    ${media.greaterThan('medium')`
        padding-right: 3rem;
    `}
`;

export const UserTypeContentSubtitle = styled.p`
    color: var(--main-color);
    font-size: 1.125rem;
    font-weight: 500;
    margin-bottom: 1.25rem;
`;

export const UserTypeContentGrid = styled.div`
    display: grid;
    grid-gap: 1rem;
    margin-bottom: 4rem;

    ${media.greaterThan('medium')`
        grid-template-columns: 1fr 1fr;
    `}
`;
